let code = 'eplgestao';
let codeAPI = 'epl';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};